import { createLocation as createLocationOp } from '@gql/operations'
import { type GqlExecutor } from '@hopdrive/sdk-core'
import { LocationValidationError } from '../../errors/location-errors'
import { CreateLocationInputSchema } from '../../validation/location-schemas'
import type { Location, CreateLocationInput } from '../../types'

export interface CreateLocationParams extends CreateLocationInput {
  executor?: GqlExecutor
}

/**
 * Create a new location record.
 */
export async function createLocation(params: CreateLocationParams): Promise<Location> {
  const parseResult = CreateLocationInputSchema.safeParse(params)
  if (!parseResult.success) {
    throw new LocationValidationError(parseResult.error)
  }

  const location = await createLocationOp(
    {
      location: {
        customer_id: params.customerId,
        name: params.name,
        address: params.address,
        address_line_one: params.addressLineOne,
        address_line_two: params.addressLineTwo,
        city: params.city,
        state: params.state,
        zip_code: params.zipCode,
        latitude: params.latitude,
        longitude: params.longitude,
        place_id: params.placeId,
        plus_code: params.plusCode,
        region_id: params.regionId,
        timezone: params.timezone,
        type: params.type ?? 'customer',
        customer_ref: params.customerRef,
        coordinates_source: params.coordinatesSource ?? 'geocoded',
        geocoding_source: params.geocodingSource ?? 'google_geocoding',
        // Always populate geocoded coordinates - default to lat/lon if not explicitly provided
        geocoded_latitude: params.geocodedLatitude ?? params.latitude,
        geocoded_longitude: params.geocodedLongitude ?? params.longitude,
        geocoded_at: new Date().toISOString(),
        place_id_authoritative: params.placeIdAuthoritative ?? true,
        active: 1,
      },
    },
    { executor: params.executor }
  )

  return location as Location
}
